import { ConfirmDialog } from '@kanos/web-core';
import type { UseMutationResult } from '@tanstack/react-query';
import { useState } from 'react';

/** What the help's entries share - questions and announcements: saved new or changed. */
type Save<T> = UseMutationResult<unknown, Error, { id: string | null; body: T }>;

/**
 * The form of one entry of the platform's content: `submit` takes the checked input, or `null`
 * when the form does not fit - then the dialog says so, else it saves and closes.
 */
export function useEntryForm<T>(save: Save<T>, id: string | null, onClose: () => void) {
  const [unfit, setUnfit] = useState(false);
  return {
    submit: (checked: T | null) => {
      setUnfit(checked === null);
      if (checked) save.mutate({ id, body: checked }, { onSuccess: onClose });
    },
    dialog: { isPending: save.isPending, error: save.error, unfit },
  };
}

/** Asks before an entry goes - for every app at once, and for good. */
export function DeleteEntryDialog({
  title,
  description,
  remove,
  id,
  onClose,
}: {
  title: string;
  description: string;
  remove: UseMutationResult<unknown, Error, string>;
  id: string;
  onClose: () => void;
}) {
  return (
    <ConfirmDialog
      title={title}
      description={`${description} Das lässt sich nicht rückgängig machen.`}
      confirmLabel="Löschen"
      isPending={remove.isPending}
      error={remove.error}
      onConfirm={() => remove.mutate(id, { onSuccess: onClose })}
      onClose={onClose}
    />
  );
}
